import React from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Controller } from "react-hook-form";
import { classNames } from "primereact/utils";


const EzControlledInputAreaWithFloatingLabel = (props) => {
  const {
    control,
    name,
    disabled,
    type,
    rules,
    labelClassName,
    onChange,
    label,
    errorMsg,
    isError,
  } = props;

  return (
    <div className="field">
      <span className="p-float-label">
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field, fieldState }) => (
            <InputTextarea
              type={type}
              id={field.name}
              name={field.name}
              disabled={disabled}
              {...field}
              onChange={(e) => {
                field.onChange(e);
                if (onChange) onChange(e);
              }}
              className={classNames(
                { "p-invalid": fieldState.invalid },
                labelClassName,
              )}
            />
          )}
        />

        <label htmlFor={name}>
          {rules?.required ? `${label}*` : label}
        </label>
      </span>
      {errorMsg}
    </div>
  );
};

EzControlledInputAreaWithFloatingLabel.defaultProps = {
  labelClassName: "",
  disabled: false,
  type: "text",
};

export default EzControlledInputAreaWithFloatingLabel;
